import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {hideModal} from "../../../store/actions/display";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import classNames from 'classnames';

class ReduxModalWrapper extends Component {

    toggle = () => {
        this.props.hideModal();
    };

    render() {
        const {modal, fullscreen, size, headerStyle, bodyStyle, footerStyle} = this.props;

        const modalClassName = classNames({
            'fs-modal': fullscreen
        });

        const contentClassName = classNames({
            'fs-modal-content': fullscreen
        });

        return modal ? (
            <div>
                <Modal size={!fullscreen ? size : null} className={modalClassName} contentClassName={contentClassName} isOpen={!!modal} toggle={this.toggle}>
                    {
                        modal.header && (
                            <ModalHeader toggle={this.toggle} style={headerStyle}>
                                {modal.header}
                            </ModalHeader>
                        )
                    }

                    {
                        modal.body && (
                            <ModalBody style={bodyStyle}>
                                {modal.body}
                            </ModalBody>
                        )
                    }

                    {
                        modal.footer && (
                            <ModalFooter style={footerStyle}>
                                {modal.footer}
                            </ModalFooter>
                        )
                    }
                </Modal>
            </div>
        ) : null;
    }
}

ReduxModalWrapper.propTypes = {
    id: PropTypes.any.isRequired,
    fullscreen: PropTypes.bool,
    size: PropTypes.string,
    headerStyle: PropTypes.object,
    bodyStyle: PropTypes.object,
    footerStyle: PropTypes.object,
};

const mapStateToProps = (state, props) => ({
    modal: state.display.modals.find((i) => i.id === props.id)
});

const mapDispatchToProps = (dispatch, props) => ({
    hideModal() {
        return dispatch(hideModal(props.id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReduxModalWrapper);


// WEBPACK FOOTER //
// ./src/components/display/Modals/ReduxModalWrapper.js